import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent!');
    setFormData({
      name: '',
      email: '',
    });
  };

  return (
    <div className="bg-[#5D685B] py-12 px-4 text-white" id="contact">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Use Cases */}
        <div>
          <h3 className="text-[18px] font-bold mb-4">Use Cases</h3>
          {/* Special Line */}
          <div className="flex items-left justify-left w-full"></div>
          <div className="border-t border-[#BCBCBC] w-1/5"></div>
          <div className="my-4"></div>
          {/* Content */}
          <ul className="text-[14px] font-semibold space-y-2">
            <li><NavLink to="#Web Designers" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Web Designers
            </NavLink></li>
            <li><NavLink to="#Marketers" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Marketers
            </NavLink></li>
            <li><NavLink to="#Small Buisnesses" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Small Businesses
            </NavLink></li>
            <li><NavLink to="#Website Builders" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Website Builders
            </NavLink></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h3 className="text-[18px] font-bold mb-4">Company</h3>
          {/* Special Line */}
          <div className="flex items-left justify-left w-full"></div>
          <div className="border-t border-[#BCBCBC] w-1/5"></div>
          <div className="my-4"></div>
          {/* Content */}
          <ul className="text-[14px] font-semibold space-y-2">
            <li><NavLink to="#About Us" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              About Us
            </NavLink></li>
            <li><NavLink to="#Careers" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Careers
            </NavLink></li>
            <li><NavLink to="#FAQs" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              FAQs
            </NavLink></li>
            <li><NavLink to="#Teams" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Teams
            </NavLink></li>
            <li><NavLink to="#Contact Us" //Please remember to replace with link
            className="text-[#0000000] hover:text-blue-500 transition duration-300">
              Contact Us
            </NavLink></li>
          </ul>
        </div>

        {/* Contact Form */}
        <div>
          <h3 className="text-[18px] font-bold mb-4">Contact Us</h3>
          <div className="my-7"></div>
          {/* First Name */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="First Name"
                className="w-full px-4 py-1 bg-gray-200 text-gray-700 text-[14px] font-Roboto font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            {/* Email */}
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                className="w-full px-4 py-1 bg-gray-200 text-gray-700 text-[14px] font-Roboto font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            {/* Send Button */}
            <button
              type="submit"
              className="w-auto bg-[#ffffff] text-[#000000] text-[14px] px-10 py-1 font-Roboto font-semibold shadow-lg transition-all transform hover:-translate-y-1"
            >
              Send
            </button>
          </form>
        </div>

        {/* Follow Us */}
        <div className="flex flex-col items-center">
          {/* Logo */}
          <img src="/ESG_Logo.png" alt="Company Logo" className="h-16 mb-4" />

          <div className="flex flex-col items-left">
            <h3 className="text-[18px] font-bold mb-4">Follow Us</h3>
            {/* Special Line */}
            <div className="flex items-left justify-left w-full"></div>
            <div className="border-t border-[#BCBCBC] w-1/5"></div>
            <div className="my-3"></div>
            {/* Icons */}
            <div className="flex space-x-8"> {/* Increased space between icons */}
              <NavLink to="https://facebook.com" aria-label="Facebook"> {/* Include Actual FB link */}
                <img src="/Home_Page_Icon_8.png" alt="Facebook" className="h-6 transition-all transform hover:-translate-y-1" />
              </NavLink>
              <NavLink to="https://twitter.com" aria-label="Twitter"> {/* Include Actual X link */}
                <img src="/Home_Page_Icon_9.png" alt="Twitter" className="h-6 transition-all transform hover:-translate-y-1" />
              </NavLink>
              <NavLink to="https://instagram.com" aria-label="Instagram"> {/* Include Actual Telegram link */}
                <img src="/Home_Page_Icon_10.png" alt="Instagram" className="h-6 transition-all transform hover:-translate-y-1" />
              </NavLink>
              <NavLink to="https://linkedin.com" aria-label="LinkedIn"> {/* Include Actual IG link */}
                <img src="/Home_Page_Icon_11.png" alt="LinkedIn" className="h-6 transition-all transform hover:-translate-y-1" />
              </NavLink>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
